import {
  BillingApi,
  CoachApi,
  Configuration,
  HubApi,
  RoleApi,
  SessionApi,
  UserApi,
} from '@addmile/backend-client';

const config = new Configuration({
  basePath: import.meta.env.VITE_BASE_BACKEND_BASE_URL,
});

export const withAuthHeader = (token: string) => {
  if (!token) {
    throw new Error('Authorization token is not found');
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const userApi = new UserApi(config);
export const coachApi = new CoachApi(config);
export const sessionApi = new SessionApi(config);
export const hubApi = new HubApi(config);
export const roleApi = new RoleApi(config);
export const billingApi = new BillingApi(config);
